<template>
  <div v-if="isExternal" :style="styleExternalIcon" class="svg-external-icon svg-icon"></div>
  <svg v-else :style="svgStyle" class="flex items-center justify-center" aria-hidden="true" fill="currentColor">
    <use :xlink:href="prefix + name"></use>
  </svg>
</template>

<script lang="ts" setup>
const props = defineProps({
  prefix: {
    type: String,
    default: '#icon-',
  },
  name: {
    type: String || undefined,
    default: '',
  },
  color: {
    type: String,
    default: 'inherit',
  },
  width: {
    type: String,
    default: '20px',
  },
  height: {
    type: String,
    default: '20px',
  },
});

//是否外部链接
const isExternal = computed(() => {
  return /^(https?:|mailto:|tel:)/.test(props.name);
});

const svgStyle = computed(() => {
  return {
    width: props.width,
    height: props.height,
    color: props.color === 'inherit' ? '' : props.color,
  };
});

const styleExternalIcon = computed(() => {
  return {
    mask: `url(${props.name}) no-repeat 50% 50%`,
    '-webkit-mask': `url(${props.name}) no-repeat 50% 50%`,
  };
});
</script>

<style scoped></style>
